import { FormSchema } from "../../../components/dynamicform/DynamicFormTypes";

const doiVersions = (window.env?.publication?.abcdForm?.doiVersions ?? [])
    .slice()
    .sort((a: any, b: any) => `${a.value}`.localeCompare(`${b.value}`, undefined, { numeric: true }))
    .map((version: any) => ({
        label: `${version.value} <a href="${version.url}" target="_blank">Link to ${version.value} Release</a>`,
        value: `${version.value}`
    }))

export const abcdForm: FormSchema = {
    title: "ABCD Information",
    fields: [
        {
            name: "abcdDomains",
            type: "checkbox",
            label: "ABCD Domains",
            numColumns: 2,
            validationRules: {
                required: "Select at least one domain.",
                validate: {
                    atLeastOne: (v: string[]) => v.length > 0 || "Select at least one domain.",
                }
            },
            // Populated at runtime from GET /api/publications/domains, see setDomainOptions in publicationSlice.tsx
            options: []
        },
        {
            name: "abcdReleaseVersion",
            type: "radio",
            label: "Please select which release version you used for your publication?",
            defaultValue: doiVersions[0]?.value || "5.0 (DOI Link)",
            options: [
                ...(doiVersions || []),
                { label: "Other: ", value: "", dynamic: true },
            ]
        }
    ]
};